import React, { useEffect, useState } from "react";
import styled from "styled-components";
import assets from "../../../assets/assets";
import { IconController, ImgController } from "../../Scripts/ImgController";
import Ripples from "react-ripples";
import useIsMobile from "../../Scripts/useIsMobile";
import { mobileBottomSheet, mobileOverlay } from "../../Scripts/mobileBottomSheet";
const Wrapper = styled.div`
  border: 1px solid black;
  border-radius: 99px;
  cursor: pointer;
`;
const Popup = styled.div`
  position: absolute;
  top: 90px;
  z-index: 103 !important;

  .modal {
    width: 320px;
    background: #ffffff;
    border: 1px solid #f3f4f6;
    box-shadow: 0px 20px 25px -5px rgba(0, 0, 0, 0.1),
      0px 10px 10px -5px rgba(0, 0, 0, 0.04);
    border-radius: 12px;
    padding: 16px 0;
    overflow-y: scroll;
  }
  .input {
    border: 1px solid #d1d5db;
    border-radius: 8px;
    width: 100%;
    height: 36px;
    background: transparent url(${assets.svg.searchIcon}) no-repeat 8px center;
    padding: 10px 4px 10px 32px;
    margin-bottom: 8px;
  }
  .active {
    color: #0061ff;
    border-bottom: 3px solid #0061ff;
  }
  .border-CK {
    border-bottom: 1px solid #e5e7eb;
  }
  .result-list {
    overflow-y: scroll;
    max-height: 274px;
  }
  .modal::-webkit-scrollbar {
    width: 0 !important;
    display: none !important;
  }
  .result-list::-webkit-scrollbar {
    width: 0 !important;
    display: none !important;
  }
  .seperator {
    border-bottom: 1px solid #e5e7eb;
  }
  .artist-selected {
    border-left: 3px solid #0061ff;
    background: linear-gradient(
      270deg,
      rgba(0, 97, 255, 0.45) 0%,
      rgba(0, 97, 255, 0) 100%
    );
  }
  .artist-hover:hover {
    background: linear-gradient(
      270deg,
      rgba(0, 97, 255, 0.45) 0%,
      rgba(0, 97, 255, 0) 100%
    );
  }
  ${mobileBottomSheet(".modal")}
`;
const Overlay = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 102 !important;
  top: 0;
  left: 0;
  ${mobileOverlay}
`;

const ArtistSelectDropdown = ({
  setArtistFilter,
  setArtistSearch,
  datas,
  width,
  newRequest,
  setNewRequest,
  setArtistChanged,
  setAlbumFilter,
  setSongFilter,
  setSelectedAlbums,
  setSelectedSongs,
}) => {
  const [publisher, setPublisher] = useState([]);
  const [shownArtist, setShownArtist] = useState("Бүгд");
  const [popup, setPopup] = useState(false);
  const isMobile = useIsMobile();

  const handleOpen = () => {
    setPopup(true);
  };
  const artistPickHandler = (id, artistName) => {
    setArtistChanged(true);
    setPopup(false);
    setShownArtist(artistName);
    setArtistFilter("filter[artist_id]=" + id);
    setTimeout(() => {
      setNewRequest(!newRequest);
    }, 500);
  };
  useEffect(() => {
    setPublisher(JSON.parse(localStorage.getItem("Current-Publisher")));
  }, []);
  const artistMap = datas.map((artist) => {
    return (
      <Ripples
        color="#ffffff40"
        during={600}
        className="w-full"
        key={artist.id}
      >
        <div
          className={`flex flex-row gap-3 w-full items-center cursor-pointer px-4 py-2 artist-hover ${
            shownArtist === artist.name ? "artist-selected" : ""
          }`}
          onClick={() => {
            artistPickHandler(artist.id, artist.name);
          }}
        >
          <div className="h-8 w-8">
            <ImgController
              size="64"
              src={artist.cover}
              className="h-8 w-8"
              imgClassName="rounded-md"
            />
          </div>
          <div className="flex-1">
            <h5 className="text-xs font-semibold">{artist.name} </h5>
          </div>
          <div>
            <IconController src={assets.svg.chevronRight} />
          </div>
        </div>
      </Ripples>
    );
  });
  const setAllHandler = () => {
    setSelectedAlbums([]);
    setSelectedSongs([]);
    setAlbumFilter("");
    setSongFilter("");
    setArtistSearch("");
    setArtistFilter("");
    setShownArtist("Бүгд");
    setNewRequest(!newRequest);
    setPopup(false);
  };
  return (
    <>
      <Ripples color="#0061FF40" during={600} className="rounded-2xl w-full">
        <Wrapper style={{ width: isMobile ? "100%" : width + "px" }}>
          <div
            className="flex flex-row justify-center items-center px-3 py-1"
            onClick={() => {
              handleOpen();
            }}
          >
            <div className="flex-1">
              <span className="font-medium text-xs">{shownArtist}</span>
            </div>
            <div className="pl-2">
              <IconController src={assets.svg.chevronDown} alt="" />
            </div>
          </div>
        </Wrapper>
      </Ripples>
      {popup ? (
        <>
          <Overlay
            onClick={() => {
              setPopup(false);
            }}
          ></Overlay>
          <Popup>
            <div className="modal">
              <div className="pb-2 px-4">
                <input
                  type="search"
                  className="input text-xs"
                  placeholder="Хайх"
                  onChange={(e) => {
                    setArtistSearch(e.target.value);
                  }}
                />
              </div>
              <div className="flex flex-col gap-2 px-0">
                <div className="overflow-y-scroll result-list">{artistMap}</div>
                <div className="seperator"></div>
                <div
                  className="flex flex-row gap-3 items-center cursor-pointer px-4 py-1"
                  onClick={setAllHandler}
                >
                  <div className="h-6 w-8"></div>
                  <div className="flex-1">
                    <h5 className="text-xs font-semibold">Бүгд</h5>
                  </div>
                  <div>
                    <IconController src={assets.svg.chevronRight} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </Popup>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default ArtistSelectDropdown;
